interface InputLabelProps {
  label: string;
  required: boolean;
  description?: string;
  htmlFor?: string;
}

export function InputLabel({ label, required, description, htmlFor }: InputLabelProps) {
  return (
    <>
      <label class="text-sm font-medium text-theme-fg" for={htmlFor}>
        {label}
        {required && <span class="text-theme-destructive"> *</span>}
      </label>
      {description && (
        <span class="text-xs text-theme-muted-fg">{description}</span>
      )}
    </>
  );
}
